import { Card, CardHeader, SvgIcon } from '@mui/material';

import { ReactComponent as Vulnerabilities } from 'assets/images/ic_vulnerab.svg';
import { AppPrimaryButton } from 'shared/components/AppComponents';

const ShadowAIDiscovery = (): React.ReactElement => (
    <Card variant="outlined">
        <CardHeader
            avatar={
                <SvgIcon
                    component={Vulnerabilities}
                    inheritViewBox
                    className="view-icon"
                    fontSize="inherit"
                    htmlColor="#D1F27A"
                />
            }
            action={<AppPrimaryButton title="Upgrade" />}
            title="Shadow AI Discovery"
            subheader="Integration with shadow AI discovery tools is available in Teams and Enterprise plans."
        />
    </Card>
);

export default ShadowAIDiscovery;
